<div *ngIf="this.isLoading" class="se-loader">
</div>
<div class="p-2">
  <div class="top-div">
    <div class="filter-sec pt-2">
      <input type="text" title={{labels.ruleText|translate}} aria-label="search" class="input-globalsearch" size="50" placeholder={{labels.search|translate}} (input)="dt.filterGlobal($event.target.value, 'contains')">
      <a  class="SearchLink">
        <em class="fa fa-search SearchIcon"></em>
      </a>

    </div>
  </div>
  <div class="gridtbl-div mb-3">
    <div>
      <div class="rectangle-grid">
        <p-table #dt [columns]="cols" [value]="alarmRulesDetail" [paginator]="isPagination" [rows]="10" [globalFilterFields]="['alarmName']">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th scope="col" *ngFor="let col of columns" [pSortableColumn]="col.field" [ngStyle]="{'width': col.width,'display': col.display}">
                {{col.header | translate}}
                <p-sortIcon [field]="col.field" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
              </th>
              <th scope="col">{{ labels.enableDisable | translate }}</th>
              <th scope="col">{{ labels.actions | translate }}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData let-columns="columns" let-i="rowIndex">
            <tr class="rowHeight">
              <td *ngFor="let col of columns" [ngStyle]="{'width': col.width,'display': col.display}">
                <span *ngIf="col.field === 'lowlimit'">
                  {{ rowData['resourceid'] !== 1 ? rowData.lowlimit : 0 }} <span *ngIf="rowData.lowlimit!=null">:</span> {{ rowData.highlimit }}
                </span>
                <span *ngIf="col.field === 'severity'">
                  {{ rowData.severity == 1 ? 'Critical' : 'Warning' }}
                </span>
                <span *ngIf="col.field !== 'id' && col.field !== 'lowlimit' && col.field !== 'severity'" title="{{rowData[col.field]}}" appendTo="target" class="relativePosition">
                  {{rowData[col.field]}}
                </span>
              </td>
              <td>
                <label class="se-block-action switch">
                  <input type="checkbox" [(ngModel)]="rowData.isActive" class="alarmrule-block-check" (click)="EditAlarmRuleStatus(rowData, $event)"
                         (keypress)="EditAlarmRuleStatus(rowData, $event)"
                         (keydown)="EditAlarmRuleStatus(rowData, $event)"
                         (keyup)="EditAlarmRuleStatus(rowData, $event)"/>
                  <span class="slider round"></span>
                </label>
              </td>
              <td>
                <img src="assets/delete.svg" class="icon-action iconDeleteRule" (click)="DeleteAlarmRule(rowData, $event)" alt="rules" height="29" width="29"
                     (keypress)="DeleteAlarmRule(rowData, $event)"
                     (keydown)="DeleteAlarmRule(rowData, $event)"
                     (keyup)="DeleteAlarmRule(rowData, $event)"/>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr *ngIf="noData">
              <td [attr.colspan]="columns.length + 2">
                {{labels.noRecords | translate}}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>
<div class="se-dialog" *ngIf="showDeletemodal">
  <div class="se-dialog-holder">
    <div class="se-complex-header se-warning">
      <h3 class="se-dialiog-title">{{this.labels.deleteRulehead| translate}} {{ruleId}}</h3>
    </div>
    <div class="se-dialog-body se-dialog-body-delete">
      <div *ngIf="this.isLoading" class="se-loader"></div>
      {{this.messages.confirmDelete| translate}}

    </div>
    <div class="se-dialog-footer">
      <button class="se-button" (click)="closeModal()">{{labels.no | translate}}</button>
      <button class="se-button" (click)="onConfirm()">{{labels.yes | translate}}</button>
    </div>

  </div>
</div>
<template ngbModalContainer>
</template>
<p-toast class="mt10" position="top-center" key="success"></p-toast>
<p-toast class="mt10" position="top-center" key="error"></p-toast>
<p-toast position="center" key="c" (onClose)="onReject()" [baseZIndex]="5000"></p-toast>
